module.exports = __webpack_public_path__ + "img/122.33eb3c4d.jpg";